import {AppSettings} from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';

export const search = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/request-types/search?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getById = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/request-types/${params}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListItem = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/request-types/select-list-items?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
  //async, await
  // let res = await Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/request-types/select-list-items?${ObjToParam(params)}`);
  // try {
  //   let data = MapResponse(res);
  //   return data;
  // } catch (e) {
  //   console.log(`${e}`);
  // }
  // return res;
};

export const create = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).post('/api/request-types', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const checkBeforeUpdateRequestType = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/electronic-punch-list-template-request-types/check-displaying-popup-when-editing-request-type/${params.requestTypeId}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const update = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).put('/api/request-types', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const makeActive = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).put(`/api/request-types/${params}/active`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const makeInActive = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).put(`/api/request-types/${params}/inactive`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const checkPreOrientation = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).put(`/api/request-types/${params}/check-pre-orientation`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const unCheckPreOrientation = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).put(`/api/request-types/${params}/uncheck-pre-orientation`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const checkFromHomeOwner = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).put(`/api/request-types/${params}/check-from-homeowner`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const unCheckFromHomeOwner = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).put(`/api/request-types/${params}/uncheck-from-homeowner`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHomeOwnerRequestTypeList = (params) => {
  return Jwt(null, false, {headers: [{key: params.headers.key, value: params.headers.value}]}).get(`${params.endpoint}/api/portal-homeowners/request-type-list`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};




// WEBPACK FOOTER //
// ./src/Request-Types/api.js